export class WithdrawReason {
  id: string;
  name: string;
}
